import {
  ChangeDetectionStrategy,
  Component,
  Injector,
  OnInit
} from '@angular/core';
import {PlayerBaseService} from '../services/PlayerService/player.base.service';
import {SignagePlayerBase} from './signage.player.base';
import {HttpClient} from '@angular/common/http';
import { transition, style, animate, trigger } from '@angular/animations';
import * as mobile from 'is-mobile';
import {Title} from '@angular/platform-browser';
import {Log, LogTag} from '../services/Log';
import {interval, Observable, tap, of, forkJoin} from "rxjs";
import {concatMap, take, last, switchMap, map, delay} from "rxjs/operators";
import {lastMap} from "../rxjs/lastMap";
import {Expiration} from "../interfaces/Expiration";


const enterTransition = transition(':enter', [
  style({
    opacity: 0
  }),
  animate('0.5s ease-in', style({
    opacity: 1
  }))
]);

const leaveTrans = transition(':leave', [
  style({
    opacity: 1
  }),
  animate('1s ease-out', style({
    opacity: 0
  }))
])

const fadeIn = trigger('fadeIn', [
  enterTransition
]);

const fadeOut = trigger('fadeOut', [
  leaveTrans
]);

@Component({
  selector: 'signage-player-web',
  templateUrl: './signage.player.web.html',
  styleUrls: ['./signage.player.scss'],
  animations: [
    fadeIn,
    fadeOut
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignagePlayerWeb extends SignagePlayerBase implements OnInit {
  httpClient;
  titleService: Title;

  studioId;
  showF11 = false;

  constructor(protected  injector: Injector) {
    super(injector);
    this.httpClient = injector.get(HttpClient);
    this.titleService = injector.get(Title);
  }

  init(): Observable<any> {
    const logInfo = Log.getLogInfo("SignagePlayerWeb", "init", []);
    return super.init().pipe(
      concatMap(r1 => this.isValidToken()),
      concatMap( t => {
        const token: any = t;
        if (token!=null && token.status) {
          if (mobile.isMobile()==false) {
            this.showF11 = true;
            this.changeDetectorRef.detectChanges();
            return of('f11').pipe(
              delay(3000),
              tap(v => {
                this.showF11 = false;
                this.changeDetectorRef.detectChanges();
              })
            )
          } else {
            return of('completed');
          }
        } else {
          Log.w(logInfo, LogTag.SIGNAGE_PLAYER, "invalid token!!!");
          return of(null);
        }
      })
    )
  }


  isValidToken(): Observable<any> {
    const url: string = 'https://' + (this.playerService as PlayerBaseService).domain +
      '/Web/isValidToken.ashx?businessId=' + (this.playerService as PlayerBaseService).businessId +
      '&token=' + (this.playerService as PlayerBaseService).webToken;
    return (this.playerService as PlayerBaseService).caching.requestJson(url,'webservice', Expiration.Minute);
  }

  start(): Observable<any> {
    const obs1$ = super.start().pipe(
      tap( { complete: () => {
        if (this.sceneData) {
          const title = this.sceneData.Player.$.label;
          this.titleService.setTitle(title);
        }
      }})
    )
    return obs1$;
  }
}
